"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { GA_TRACKING_ID } from "~/analytics";
import { Box } from "~/components/Box/Box";
import { Button } from "~/components/Button/Button";
import { Text } from "~/components/Text/Text";

export default function GlobalError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { error } = props;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        {/* NOTE: this prevents the browser zooming
          see: https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone
          for a potentially more accessible solution */}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        {/* Disabled warning about CSS loading, we want to do it this way for now */}
        {/* eslint-disable-next-line @next/next/no-css-tags */}
        <link href="/theme.css" rel="stylesheet" />
        {/* Global Site Tag (gtag.js) - Google Analytics */}
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `,
          }}
        />
      </head>
      <body style={{ margin: 0, padding: 0 }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="full"
          height="full"
        />
        <Text size="large">
          {error.name} - {error.message}
        </Text>
        <Button onClick={props.reset}>Try again</Button>
      </body>
    </html>
  );
}
